import { StepConfigs } from './StepConfigs';
export const getStepConfig = stepKey => {
  return StepConfigs.get(stepKey);
};
export const isValidStepKey = stepKey => {
  return StepConfigs.has(stepKey);
};
export const executeStepBefore = stepKey => dispatch => {
  const stepConfig = getStepConfig(stepKey);
  if (stepConfig && stepConfig.beforeComplete) {
    dispatch(stepConfig.beforeComplete);
  }
};
export const getConfigDataOfStep = stepKey => {
  const stepConfig = getStepConfig(stepKey);
  return stepConfig && stepConfig.data;
};